// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"901":"fcc9a0c6","945":"fcc9a0c6","2326":"fcc9a0c6","3358":"9532fbe5","4326":"2cf8a440","6460":"c6bd493b","9842":"2cf8a440"}[chunkId] + ".chunk.css";
};